define(["require", "exports", "./Dimension"], function (require, exports, Dimension_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var VirtualScreen = (function () {
        function VirtualScreen() {
            this.Commect = null;
            this.RoomId = null;
            this.LocationId = null;
            this.Dimension = new Dimension_1.Dimension();
            this.PhysicalScreens = [];
            this.State = "on";
        }
        return VirtualScreen;
    }());
    exports.VirtualScreen = VirtualScreen;
});
//# sourceMappingURL=VirtualScreen.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Configuration/VirtualScreen.js
// module id = 149
// module chunks = 0